/** Common utility functions */

/* Absolutely standard linear interpolation */
export const lerp = (a, b, f) => a + ((b - a) * f);

/* More diverse interpolations */
export const interpolate = (a, b, f, func) => a + ((b - a) * func(f));

export const easeIn = p => t => Math.pow(t, p);
export const easeOut = p => t => (1 - Math.abs(Math.pow(t - 1, p)));
export const easeInOut = p => t => t < 0.5 ? easeIn(p)(t * 2) / 2 : easeOut(p)(t * 2 - 1) / 2 + 0.5;

/* Absolutely standard euclidean distance of any objects with .x and .y properties */
export const distance = (p1, p2) => Math.sqrt(((p1.x - p2.x) * (p1.x - p2.x)) + ((p1.y - p2.y) * (p1.y - p2.y)));

/* Absolutely standard bearing from p1 to p2 */
export const bearing = (p1, p2) => ((2 * Math.PI) + Math.atan2(p2.y - p1.y, p2.x - p1.x)) % (2 * Math.PI);

export const length = (a) => {
  return distance(a, { x: 0, y: 0 });
};

export const normalize = (a) => {
  const k = length(a);
  if (k === 0) {
    return {
      x: 0,
      y: 0
    };
  }
  return {
    x: a.x / k,
    y: a.y / k
  };
};

export const shuffle = (a) => {
  let j, x, i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
  return a;
};

export const transition = (callback, duration) => {
  // fire the transition at zero
  callback(0);

  const totalFrames = duration / 16;
  let framesElapsed = 0;

  const loop = () => {
    if (framesElapsed < totalFrames) {
      framesElapsed += 1;
      callback(framesElapsed / totalFrames);
      requestAnimationFrame(loop);
    } else {
      // fire the transition at one
      callback(1);
    }
  };

  requestAnimationFrame(loop);
};
